var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#BC123E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4566_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3122 12.5515C14.2838 12.5231 14.2838 12.4769 14.3122 12.4486L17.7751 8.98394C18.0712 8.68773 18.0712 8.20571 17.7751 7.90947L17.0886 7.22263C16.9451 7.07905 16.7543 7 16.5514 7C16.3484 7 16.1576 7.07905 16.0141 7.2226L12.5512 10.6873C12.5337 10.7048 12.5137 10.7085 12.5001 10.7085C12.4864 10.7085 12.4664 10.7048 12.4489 10.6873L8.98595 7.2226C8.84245 7.07905 8.65167 7 8.44872 7C8.24576 7 8.055 7.07905 7.91151 7.2226L7.22501 7.90947C6.9289 8.20571 6.9289 8.68773 7.22501 8.98394L10.6879 12.4486C10.7163 12.4769 10.7163 12.5231 10.6879 12.5515L7.22501 16.0161C6.92892 16.3123 6.92892 16.7943 7.22501 17.0906L7.91151 17.7774C8.055 17.921 8.24578 18 8.44872 18C8.65165 18 8.84245 17.921 8.98595 17.7774L12.4489 14.3128C12.4664 14.2952 12.4864 14.2916 12.5 14.2916C12.5137 14.2916 12.5337 14.2952 12.5512 14.3128L16.0141 17.7774C16.1576 17.921 16.3484 18 16.5514 18C16.7543 18 16.9451 17.921 17.0886 17.7774L17.7751 17.0906C18.0711 16.7944 18.0711 16.3123 17.7751 16.0161L14.3122 12.5515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4566_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.63923d7f2653d82b988aead9ae8a0667.svg";
export { ForwardRef as ReactComponent };